import { TaskCard } from './TaskCard'

const COLUMNS = [
  { key: 'open',        label: 'Open',        color: 'bg-gray-400' },
  { key: 'in_progress', label: 'In Progress',  color: 'bg-blue-500' },
  { key: 'completed',   label: 'Completed',    color: 'bg-green-500' },
  { key: 'cancelled',   label: 'Cancelled',    color: 'bg-red-400' },
]

export function TaskBoard({ tasks, onSelectTask, isDarkMode }) {
  const grouped = {}
  COLUMNS.forEach(({ key }) => { grouped[key] = [] })
  tasks.forEach((t) => {
    const status = t.status ?? 'open'
    if (grouped[status]) grouped[status].push(t)
    else grouped['open'].push(t)
  })

  const colBg = isDarkMode ? 'bg-slate-800/50' : 'bg-gray-50'
  const border = isDarkMode ? 'border-slate-700' : 'border-gray-200'
  const countText = isDarkMode ? 'text-slate-400' : 'text-gray-500'

  return (
    <div className="flex gap-4 p-4 overflow-x-auto h-full">
      {COLUMNS.map(({ key, label, color }) => {
        const colTasks = grouped[key]
        return (
          <div
            key={key}
            className={`flex flex-col rounded-xl border min-w-[260px] w-[280px] flex-shrink-0 ${colBg} ${border}`}
          >
            {/* Column header */}
            <div className={`flex items-center gap-2 px-3 py-2.5 border-b ${border}`}>
              <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${color}`} />
              <span className={`text-sm font-semibold flex-1 ${isDarkMode ? 'text-slate-200' : 'text-gray-700'}`}>
                {label}
              </span>
              <span className={`text-xs font-medium ${countText}`}>{colTasks.length}</span>
            </div>

            {/* Cards */}
            <div className="flex-1 overflow-y-auto p-2 space-y-2">
              {colTasks.length === 0 ? (
                <p className={`text-xs text-center py-6 ${countText}`}>No tasks</p>
              ) : (
                colTasks.map((task) => (
                  <TaskCard
                    key={task.id}
                    task={task}
                    mode="board"
                    onClick={() => onSelectTask(task.id)}
                    isDarkMode={isDarkMode}
                  />
                ))
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
